import { render, staticRenderFns } from "./BarVue.vue?vue&type=template&id=3d94d15b"
import script from "./BarVue.vue?vue&type=script&lang=js"
export * from "./BarVue.vue?vue&type=script&lang=js"
import style0 from "./BarVue.vue?vue&type=style&index=0&id=3d94d15b&prod&scopd=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports